module.exports = __webpack_public_path__ + "static/media/13.c3d47d55.png";